import { useTranslation } from 'react-i18next';

import { DocumentDetailsModel } from 'api/documents/documents.model';
import Card from 'components/Card';
import { CertificateDetailsModel } from 'models/certificate.model';

import ComponentInformation from './ComponentInformation';
import GeneralInformation from './GeneralInformation';
import Header from './Header';
import * as Styled from './Other.styles';

const Other = (certificateDocument: DocumentDetailsModel<CertificateDetailsModel>) => {
  const { t } = useTranslation();

  return (
    <Card backButtonLink="/home/certificates" padding="large">
      <>
        <Header {...certificateDocument} />
        <GeneralInformation {...certificateDocument} />
        {certificateDocument?.additionalDetails?.components?.map((component) => (
          <ComponentInformation key={component.componentId} {...component} />
        ))}
        <Styled.Divider />
        <Styled.AdditionalComments>
          {t(`certificate.additionalComments.label`)}
        </Styled.AdditionalComments>
        {certificateDocument.additionalDetails?.additionalComments}
      </>
    </Card>
  );
};

export default Other;
